import type { ReactNode } from "react";
import { Skel } from "../Skel";
import { SkelText } from "./SkelText";

// A `.panel` with its head and body. The title is static copy in most
// panels, so pass it and it renders for real; the body defaults to a
// few lines of text and takes any other skeleton as children.
type Props = {
  title?: ReactNode;
  children?: ReactNode;
};

export function SkelPanel({ title, children }: Props) {
  return (
    <div className="panel">
      <div className="panel__head">
        <div className="panel__title">{title ?? <Skel variant="text" width="30%" />}</div>
      </div>
      <div className="panel__body">{children ?? <SkelText />}</div>
    </div>
  );
}
